<div class="pageWrapper">
  <video id="background-video" lazy autoplay loop muted>
    <source defer src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/corporate%2Fvideo%2Fslow-motion-hands-clapping-high_optimized_AdobeCreativeCloudExpress.mp4?alt=media&token=e6ac162a-3284-4389-80cd-7939ec4df4c6" type="video/mp4">
  </video>
  <header>
    <div class="videoSectionWrapper">
      <app-use-us-header-video></app-use-us-header-video>
      </div>
    <div class="leaderSectionWrapper">
      <app-uu-leader></app-uu-leader>
    </div>
  </header>
</div>
